import {message} from 'antd';

const noneValue = (method, value, returnBlankString = false) => {
    if (value || (value === 0) || (value === false)) {
        return value;
    }

    //undefined, null, ''
    if (returnBlankString || (method === 'GET') || (method === 'DELETE')) {
        return '';
    } else {
        return null;
    }
};

const getRealParams = (params, ignoreBlank = true) => {
    let _params = {};

    Object.keys(params).forEach((key) => {
        if (!ignoreBlank || params[key] || (params[key] === 0) || (params[key] === false)) {
            _params[key] = params[key];
        }
    });

    return _params;
}

let clearTimer = null;

const $fetch = (url, option = {}, ignoreBlank = true, returnBlankString = false) => {
    const { method = 'GET', params={}, headers, resType = 'json', isArr = false, noMessage = false, ...other } = option;

    const apiBaseUrl = localStorage.getItem('isTest') ? 'https://test-api.mayidaipai.com' : 'https://api.mayidaipai.com';

    // console.log(apiBaseUrl);

    const {token} = JSON.parse(localStorage.getItem('userInfo') || '{}');

    const realParams = isArr ? params : getRealParams(params, ignoreBlank);

    if (!noMessage) {
        !clearTimer && (clearTimer = message.loading("请求中...", 0));
    }

    // 区分 GET 和 POST

    if ((method === 'GET') || (method === 'DELETE')) {
        let queryString = realParams ? Object.keys(realParams).map(key => `${key}=${noneValue(method, realParams[key])}`).join('&') : '';

        if (queryString && url.indexOf('?') === -1) {
            queryString = `?${queryString}`;
        }

        return new Promise((resolve, reject) => {

            fetch(`${apiBaseUrl}${url}${queryString}`, {
                method,
                credentials: 'include',
                headers: headers || {
                    'Content-Type': 'application/json',
                    access_token: token,
                },
                ...other,
            }).then(res => res[resType]()).then(resp => {

                clearTimer && clearTimer();
                clearTimer = null;

                if (resp.code === 2001) {
                    message.error('用户未登录或token已过期，请重新登录');
                    window.location.href = '/#/login';
                    localStorage.removeItem('userInfo');
                    reject({message: resp.message});
                    return;
                }

                if (resp.code === 0) {
                    return resolve(resp.data);
                }

                resp.message && message.error(resp.message);

                reject(resp);

                return resolve(resp);
            }).catch(e => {
                clearTimer && clearTimer();
                clearTimer = null;
                reject(e);
            });
        });
    }

    Object.keys(realParams).forEach(key => {
        realParams[key] = noneValue(method, realParams[key], returnBlankString);
    });

    return new Promise((resolve, reject) => {

        fetch(`${apiBaseUrl}${url}`, {
            method,
            body: JSON.stringify(realParams),
            credentials: 'include',
            headers: headers || {
                'Content-Type': 'application/json',
                access_token: token,
            },
            ...other,
        }).then(res => res[resType]()).then(resp => {
            clearTimer && clearTimer();
            clearTimer = null;

            if (resp.code === 2001) {
                message.error('用户未登录或token已过期，请重新登录');
                window.location.href = '/#/login';
                localStorage.removeItem('userInfo');
                reject({message: resp.message});
                return;
            }

            if (resp.code === 0) {
                return resolve(resp.data);
            }

            resp.message && message.error(resp.message);

            reject(resp);

        }).catch(e => {
            console.log(e);
            clearTimer && clearTimer();
            clearTimer = null;

            e.message && message.error(e.message);
            reject(e);
        });
    });
};

export default $fetch;